import { Button, Icon } from '@/ui';

import type { AIPrompt } from '@/store/api/mcpMemberApi';
import type { FC } from 'react';

interface PromptCardProps {
  onCopy: (text: string) => void;
  prompt: AIPrompt;
}

// Copy-only (contracts §8.15).
const PromptCard: FC<PromptCardProps> = ({ onCopy, prompt }) => (
  <div className="mb-2.5 rounded-2xl bg-white p-4 shadow">
    <small className="mb-1.5 block text-[13px] font-semibold text-sage-500">
      {prompt.when}
    </small>
    <q className="block text-base leading-relaxed [quotes:none]">
      {prompt.text}
    </q>
    <div className="mt-3 flex flex-wrap gap-2">
      <Button
        size="small"
        startIcon={<Icon>content_copy</Icon>}
        variant="contained"
        onClick={() => onCopy(prompt.text)}
      >
        Copy prompt
      </Button>
    </div>
  </div>
);

export default PromptCard;
